
import { FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { Location_$reflection, LocationDetailDto_$reflection } from "../../Shared/Location.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapLocationId } from "../../Shared/Helper.js";
import { string_type, list_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function initViewLocationView(locationId) {
    return [new State(new RequestedValue$1(0, []), new RequestedValue$1(0, []), false, FormState_get_empty()), Cmd_batch(ofArray([Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), LocationDetailDto_$reflection()));
    })))), concat("/api/locations/", ...unwrapLocationId(locationId)), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(5, [Item_1]))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Location_$reflection())));
    })))), "/api/locations", (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))]))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 4:
            return [new State(state.Location, new RequestedValue$1(1, [msg.fields[0]]), state.IsDeleteDialogOpen, state.FormState), Cmd_none()];
        case 5:
            return [new State(state.Location, state.Locations, false, FormState_get_empty()), Cmd_errorToast("storage.fail_fetch_data")];
        case 0:
            return [new State(state.Location, state.Locations, true, state.FormState), Cmd_none()];
        case 1:
            return [new State(state.Location, state.Locations, false, state.FormState), Cmd_none()];
        case 2: {
            const matchValue = state.Location;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.Location, state.Locations, state.IsDeleteDialogOpen, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix_1(url), (refreshOn) => fetchWithDecoder_1(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), concat("/api/locations/", ...matchValue.fields[0].Id), (Item) => (new Msg(6, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 6: {
            const response_2 = msg.fields[0];
            const closedState = new State(state.Location, state.Locations, false, FormState_get_empty());
            if (response_2.tag === 1) {
                return [closedState, Cmd_errorToast(defaultArg(response_2.fields[0].GlobalValidationMessage, "location.location_deleted_error"))];
            }
            else {
                return [closedState, Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    RouterModule_nav(singleton("locations"), 1, 1);
                }), Cmd_successToast("location.location_deleted_success")]))];
            }
        }
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.Locations, state.IsDeleteDialogOpen, state.FormState), Cmd_none()];
    }
}

